module.exports = __webpack_public_path__ + "static/media/logo.e14e0f1b.svg";